/**
* @Author: Dmytro Mykhailov <dmitriymikhaylov>
* @Date:   2016-10-13T17:48:37+03:00
* @Email:  belindream@gmail.com
* @Project: Lumand
* @Last modified by:   dmitriymikhaylov
* @Last modified time: 2016-10-14T13:27:03+03:00
* @License: MIT
*/



import React from 'react'
import { connect } from 'react-redux'
import RaisedButton from 'material-ui/RaisedButton'


export default (o) => (
  <div
    style={{
      position: "fixed",
      left: "0",
      top: "0",
      height: "100%",
      width: "100%",
      backgroundColor: "rgba(0,0,0,0.7)"
    }}
  >
    <div
      style={{
        position: "absolute",
        width: "600px",
        height: "380px",
        left: "0",
        right: "0",
        bottom:"0",
        top: "0",
        margin: "auto",
        backgroundColor: "#FFF",
        maxWidth: "100%"
      }}
    >
      <img
        src={'/' + process.env.REACT_APP_NAME + "/static/img/death_star.jpg"}
        style={{
          width: "300px"
          , display: "block"
          , margin: "auto"
        }}
      />
      <p
        style={{
          textAlign: "center"
        }}
      >
        Something went very wrong
      </p>
      <RaisedButton
        label="Refresh"
        secondary={true}
        style={{
          margin: "auto",
          display: "block"
        }}
        onClick={() => window.location.reload()}
      />
      <RaisedButton
        label="Home"
        secondary={true}
        style={{
          margin: "auto",
          display: "block",
		  textAlign: "center"
        }}
		href="/manager/home"
      />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Error.js